import React from 'react';
import SideNav, { Nav, NavIcon, NavText } from 'react-sidenav';
import {Link} from 'react-router-dom';

//Style
import '../../css/common.css';

/**
 * @param obj - one navigation item
 * @param type - topic type ("class", "test" or "exam")
 * @return {string} topic title (based on topic type)
 */
function getTitle(obj, type){
    if(type === "class")
    {
        return "Tema " + obj.week + ": " + obj.topicName;
    }
    else if(type === "test")
    {
        return obj.year + ": " + obj.description;
    }
    else
    {
        return obj.year + ": " + obj.name;
    }
}

/**
 * @param list - topic collection
 * @param type - topic type ("class", "test" or "exam")
 * @param courseId
 * @return Navigation list where each topic is one item
 */
function generateNavigationItemList(list, type, courseId) {
    var result = list.map((item) => {
        var allDone = (item.cnt === item.correct_cnt);
        var halfDone = (item.cnt/2 < item.correct_cnt);

        var href="/s/courses/"+ courseId+ "/topic/" + item.id;
        return  (
            <Nav id={item.id}>
                <NavText>
                    <Link className="default-link" to={href}>
                        {allDone ? <span className="fa fa-check-square-o" style={{color: 'lightgreen'}}> </span> :
                            halfDone? <span className="fa fa-edit" style={{color: 'orange'}}></span> :
                                <span className="fa fa-book" style={{color: 'lightcoral'}}></span>}
                        &nbsp; {getTitle(item, type)}
                    </Link>
                </NavText>
            </Nav>
        );
    });

    return result;
}

function SideNavbar({classes, tests, exams, courseInfo}) {
    var classesHtml = generateNavigationItemList(classes, "class", courseInfo.idCourse);
    var testsHtml = generateNavigationItemList(tests, "test", courseInfo.idCourse);
    var examsHtml = generateNavigationItemList(exams, "exam", courseInfo.idCourse);

    return (
        <div id="sidenavcontainer" className="col-md-3">
            <SideNav highlightColor='white' highlightBgColor='' defaultSelected='sales'>
                <div style={{padding: '20px', textAlign: 'center'}}>
                    <Link className="default-link" to={"/s/courses/"+ courseInfo.idCourse}>{courseInfo.name} </Link>
                </div>
                <Nav id='vezbe'>
                    <NavIcon> <span className="fa fa-keyboard-o"> </span> </NavIcon>
                    <NavText> Časovi vežbi </NavText>
                    {classesHtml}
                </Nav>

                <Nav id='tests'>
                    <NavIcon> <span className="fa fa-code"> </span> </NavIcon>
                    <NavText> Kolokvijumi </NavText>
                    {testsHtml}
                </Nav>

                <Nav id='exams'>
                    <NavIcon> <span className="fa fa-question-circle"> </span> </NavIcon>
                    <NavText> Ispiti </NavText>
                    {examsHtml}
                </Nav>
                <Nav>
                    <NavIcon> <span className="fa fa-list"> </span> </NavIcon>
                    <NavText>
                        <Link className="default-link" to = {"/s/courses/" + courseInfo.idCourse + "/allProblems"}>Svi problemi</Link>
                    </NavText>
                </Nav>
            </SideNav>
        </div>
    );
}

export default SideNavbar;